"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ODataUrlBuilder = void 0;
/**
 * Helper class to build OData Urls
 */
class ODataUrlBuilder {
    static combineODataFieldParameters(...params) {
        const filtered = params.filter(Boolean);
        const flatten = filtered.reduce((previousValue, currentValue) => previousValue.concat(currentValue), []);
        return [...new Set(flatten)];
    }
    /**
     * Method to build proper parameter string to OData requests based on the given repository configuration and option Object.
     *
     * Checks whether a given parameter is standard OData param or not and based on this information this params get the '$' sign.
     * @param {RepositoryConfiguration} config Represents the current Repository configuration for default select, expand, etc... options
     * @param {ODataParams} options Represents an ODataOptions object. Holds the possible url parameters as properties.
     * @returns {string} String with the url params in the correct format e.g. '$select=DisplayName,Index'&$top=2&metadata=no'.
     */
    static buildUrlParamString(config, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        const oDataParams = Object.assign({}, options);
        if (config.requiredSelect === 'all' || config.defaultSelect === 'all' || (oDataParams === null || oDataParams === void 0 ? void 0 : oDataParams.select) === 'all') {
            oDataParams.select = undefined;
        }
        else {
            oDataParams.select = this.combineODataFieldParameters(config.requiredSelect, (_a = oDataParams.select) !== null && _a !== void 0 ? _a : config.defaultSelect);
        }
        oDataParams.metadata = (_b = oDataParams.metadata) !== null && _b !== void 0 ? _b : config.defaultMetadata;
        oDataParams.inlinecount = (_c = oDataParams.inlinecount) !== null && _c !== void 0 ? _c : config.defaultInlineCount;
        oDataParams.expand = (_d = oDataParams.expand) !== null && _d !== void 0 ? _d : config.defaultExpand;
        oDataParams.top = (_e = oDataParams.top) !== null && _e !== void 0 ? _e : config.defaultTop;
        oDataParams.enableautofilters = (_f = oDataParams.enableautofilters) !== null && _f !== void 0 ? _f : config.defaultEnableAutofilters;
        oDataParams.enablelifespanfilter = (_g = oDataParams.enablelifespanfilter) !== null && _g !== void 0 ? _g : config.defaultEnableLifespanfilter;
        const segments = [];
        for (const key in oDataParams) {
            const name = this.ODATA_PARAMS.includes(key) ? `$${key}` : key;
            const plainValue = oDataParams[key];
            let parsedValue = plainValue;
            if (plainValue instanceof Array && plainValue.length) {
                parsedValue = plainValue.map((v) => { var _a, _b; return (_b = (_a = v.join) === null || _a === void 0 ? void 0 : _a.call(v, ' ')) !== null && _b !== void 0 ? _b : v; }).join(',');
            }
            if (name && parsedValue && parsedValue.toString().length) {
                segments.push({ name, value: parsedValue });
            }
        }
        return segments.map((s) => `${s.name}=${encodeURIComponent(s.value)}`).join('&');
    }
}
exports.ODataUrlBuilder = ODataUrlBuilder;
/**
 * List of a valid OData parameters
 */
ODataUrlBuilder.ODATA_PARAMS = [
    'select',
    'expand',
    'orderby',
    'top',
    'skip',
    'filter',
    'format',
    'inlinecount',
];
//# sourceMappingURL=ODataUrlBuilder.js.map